const locale = {
  JOB_TITLE_TEXT_ADDITIONAL: 'For your <b>{{jobTitle}}</b> career',
};

export default locale;
